const dictionary = {
	Correo: "email",
	Nombre: "name",
	Teléfono: "phone",
	Telefono: "phone",
	"Rut/Dni": "rut",
};

export const getUserInfo = (user, fieldName) => {
	if (!user || !fieldName) return null;

	const inputName = dictionary[fieldName];
	return user[inputName];
};
